"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { LINKS } from "@/consts/global";
import { useIsClient } from "@/hooks/use-is-client";
import { useHasFeatureAccess } from "@/hooks/useHasFeatureAccess";
import { useAuth } from "@/providers/auth";
import { NAVBAR_LINKS_GROUPS } from "./consts";

/**
 * Shared hook for filtering navbar links based on authentication state and feature access.
 * This ensures mobile and desktop menus always show the same available options.
 *
 * Auth-dependent links stay in the logged-out shape until the client has mounted and the
 * session has resolved — avoids SSR/hydration mismatches in NavbarMenu.
 */
export function useNavbarLinks() {
  const $ = _c(9);
  const {
    isLoggedIn,
    isSessionResolving
  } = useAuth();
  const hasFavoritesAccess = useHasFeatureAccess("favorites");
  const isClient = useIsClient();
  const canResolveNavAuth = isClient && !isSessionResolving;
  const navLoggedIn = canResolveNavAuth && isLoggedIn;
  const navFavoritesAccess = canResolveNavAuth && hasFavoritesAccess;
  const [primaryLinks, secondaryLinks] = NAVBAR_LINKS_GROUPS;
  let t0;
  if ($[0] !== navFavoritesAccess || $[1] !== navLoggedIn) {
    t0 = primaryLinks.links.filter(link => {
      const shouldDisplay = link.shouldDisplay === "always" || navLoggedIn && link.shouldDisplay === "logged-in" || !navLoggedIn && link.shouldDisplay === "logged-out";
      if (link.link.href === LINKS.Favorites.href) {
        return shouldDisplay && navFavoritesAccess;
      }
      return shouldDisplay;
    }).map(_temp);
    $[0] = navFavoritesAccess;
    $[1] = navLoggedIn;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const filteredPrimaryLinks = t0;
  let t1;
  if ($[3] !== navLoggedIn) {
    t1 = secondaryLinks.links.filter(link_1 => link_1.shouldDisplay === "always" || navLoggedIn && link_1.shouldDisplay === "logged-in" || !navLoggedIn && link_1.shouldDisplay === "logged-out").map(_temp2);
    $[3] = navLoggedIn;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const filteredSecondaryLinks = t1;
  let t2;
  if ($[5] !== filteredPrimaryLinks || $[6] !== filteredSecondaryLinks || $[7] !== navLoggedIn) {
    t2 = {
      filteredPrimaryLinks,
      filteredSecondaryLinks,
      navLoggedIn
    };
    $[5] = filteredPrimaryLinks;
    $[6] = filteredSecondaryLinks;
    $[7] = navLoggedIn;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(link_2) {
  return link_2.link;
}
function _temp(link_0) {
  return link_0.link;
}